"use client";

/**
 * @file deployment skew を検知したときに、再読み込み導線付きの toast を表示する常駐コンポーネント。
 */

import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { useEffect } from "react";
import { toast } from "sonner";
import { subscribeToStaleDeployment } from "@/lib/stale-deployment";

/** 再表示ではなく既存 toast を更新するための固定 ID。 */
const TOAST_ID = "stale-deployment";

/**
 * deployment skew の通知を購読し、再読み込みを促す toast を表示する。
 * 再読み込みするまで復旧しないため、toast は自動では閉じない。
 * @returns 描画物を持たないため null。
 */
export function StaleDeploymentNotifier() {
  const { i18n } = useLingui();

  useEffect(
    () =>
      subscribeToStaleDeployment(() => {
        toast.error(i18n._(msg`A new version has been released.`), {
          id: TOAST_ID,
          description: i18n._(
            msg`Reload the page and try again. The page you are viewing is out of date.`,
          ),
          duration: Number.POSITIVE_INFINITY,
          action: {
            label: i18n._(msg`Reload`),
            onClick: () => {
              window.location.reload();
            },
          },
        });
      }),
    [i18n],
  );

  return null;
}
